import {
  MdAccountTree,
  MdAddChart,
  MdAreaChart,
  MdBarChart,
  MdCarRental,
  MdFormatAlignCenter,
  MdGroups,
  MdHome,
  MdHomeWork,
  MdMap,
  MdNotificationsActive,
  MdPersonPin,
  MdReadMore,
  MdTask,
} from 'react-icons/md';

import { BsGear, BsPersonFillGear } from 'react-icons/bs';

import AdminComptes from 'views/admin/adminCompte/AdminComptes';
import EnterpriseAcccount from 'views/admin/adminCompte/EnterpriseAcccount';
import Requests from 'views/admin/adminCompte/Requests/Requests';
import RequestsAccount from 'views/admin/adminCompte/Requests/RequestsAccount';
import Comptes from 'views/admin/comptes/Comptes';
import TabBar from 'views/admin/default/components/TabBar';
import Demandes from 'views/admin/demandes/Demandes';
import EmployeList from 'views/admin/employes/EmployeList';
import EmployesByEnterprise from 'views/admin/employes/EmployesByEnterprise';
import Missions from 'views/admin/Missions/Mission';
import Notifications from 'views/admin/notification/Notifications';
import Activities from 'views/admin/reports/Activities';
import Reports from 'views/admin/reports/Reports';
import ReportsSimple from 'views/admin/reports/ReportsSimple';
import Roles from 'views/admin/roles/Roles';
import AddEnterprisePage from 'views/admin/enterprises/AddEnterprisePage';
import EmployersByUsers from 'views/admin/enterprises/EmployersByUsers';
import EnterprisesByUsers from 'views/admin/enterprises/enterpriseByUsers';
import Enterprises from 'views/admin/enterprises/Enterprises';
import Tasks from 'views/admin/Tasks/Tasks';
import UserEmployes from 'views/admin/userEmployes';
import UserEnterprises from 'views/admin/userEnterprises';
import Zones from 'views/admin/zone/Zones';
import UserActivityPage from 'views/admin/userActivity';
import NotificationSchedulerPage from 'views/admin/notificationScheduler';
import EmailVerification from 'views/auth/EmailVerification';
import SignIn from 'views/auth/SignIn';

// Routes d'authentification
export const authRoutes = [
  {
    name: 'Login',
    layout: '/auth',
    path: 'sign-in',
    component: <SignIn />,
  },
  {
    name: 'Login',
    layout: '/auth',
    path: 'email-verification',
    component: <EmailVerification />,
  },
];

// Routes principales avec clés de traduction
const routes = [
  {
    name: 'stats_title', // Clé de traduction au lieu du texte traduit
    layout: '/admin',
    path: 'stats',
    icon: <MdBarChart className="" size={25} />,
    displayOnSideBar: true,
    permissionName: 'Voir menu statistiques',
    component: <TabBar />,
    roles: ['ADMIN', 'DGSN', 'MINREX', 'QUALITY'],
  },

  {
    name: 'enterprises_title',
    layout: '/admin',
    icon: <MdHomeWork className="h-6 w-6" />,
    permissionName: 'Voir menu entreprise',
    displayOnSideBar: true,
    path: 'enterprises',
    component: <Enterprises />,
    roles: ['ADMIN', 'DGSN', 'MINREX', 'QUALITY', 'DRMO', 'AGENT'],
  },
  {
    name: 'enterprises_details_title',
    layout: '/admin',
    path: 'enterprises/:id',
    component: <AddEnterprisePage />,
    icon: <MdHome className="h-6 w-6" />,
    permissionName: 'Voir menu entreprise',
    displayOnSideBar: false,
    roles: ['ADMIN', 'DGSN', 'MINREX', 'QUALITY', 'DRMO', 'AGENT'],
  },
  {
    name: 'employees_title',
    layout: '/admin',
    icon: <MdPersonPin className="h-6 w-6" />,
    permissionName: 'Voir menu employé',
    displayOnSideBar: true,
    path: 'employes',
    component: <EmployeList />,
    roles: ['ADMIN', 'DGSN', 'MINREX', 'QUALITY', 'DRMO', 'AGENT'],
  },
  {
    name: 'activities_title',
    layout: '/admin',
    icon: <MdAreaChart className="h-6 w-6" />,
    displayOnSideBar: true,
    path: 'activities',
    component: <Activities />,
    roles: ['ADMIN', 'QUALITY'],
  },
  {
    name: 'demandes_title',
    layout: '/admin',
    icon: <MdReadMore className="h-6 w-6" />,
    displayOnSideBar: true,
    path: 'demandes',
    component: <Demandes />,
    roles: ['ADMIN', 'QUALITY'],
  },
  {
    name: 'reports_title',
    layout: '/admin',
    icon: <MdAddChart className="h-6 w-6" />,
    path: 'reports',
    displayOnSideBar: false,
    component: <Reports />,
    roles: ['ADMIN', 'QUALITY'],
  },
  {
    name: 'reports_doc_title',
    layout: '/admin',
    icon: <MdAddChart className="h-6 w-6" />,
    path: 'reports-doc',
    displayOnSideBar: true,
    component: <ReportsSimple />,
    roles: ['ADMIN', 'QUALITY', 'AGENT'],
  },
  {
    name: 'zones_title',
    layout: '/admin',
    icon: <MdMap className="h-6 w-6" />,
    displayOnSideBar: true,
    path: 'zones',
    component: <Zones />,
    roles: ['ADMIN', 'QUALITY'],
  },
  {
    name: 'missions_title',
    layout: '/admin',
    icon: <MdCarRental className="h-6 w-6" />,
    displayOnSideBar: true,
    path: 'missions',
    component: <Missions />,
    roles: ['ADMIN', 'QUALITY'],
  },
  {
    name: 'tasks_title',
    layout: '/admin',
    icon: <MdTask className="h-6 w-6" />,
    displayOnSideBar: true,
    path: 'tasks',
    component: <Tasks />,
    roles: ['ADMIN', 'QUALITY'],
  },
  {
    name: 'enterprises_us_title',
    layout: '/admin',
    icon: <MdBarChart className="h-6 w-6" />,
    path: 'enterprises/:agentId',
    displayOnSideBar: false,
    component: <EnterprisesByUsers />,
    roles: ['ADMIN', 'DGSN', 'MINREX', 'QUALITY'],
  },
  {
    name: 'employees_us_title',
    layout: '/admin',
    icon: <MdBarChart className="h-6 w-6" />,
    path: 'employees/agents/:agentId',
    displayOnSideBar: false,
    component: <EmployersByUsers />,
    roles: ['ADMIN', 'DGSN', 'MINREX', 'QUALITY'],
  },
  {
    name: 'employees_by_enterprise_title',
    layout: '/admin',
    icon: <MdBarChart className="h-6 w-6" />,
    permissionName: 'Voir liste des employes',
    displayOnSideBar: false,
    path: 'employees/:id',
    component: <EmployesByEnterprise />,
    roles: ['ADMIN', 'DGSN', 'MINREX', 'QUALITY', 'DRMO'],
  },

  {
    name: 'comptes_agents_title',
    layout: '/admin',
    displayOnSideBar: true,
    path: 'comptes',
    icon: <MdGroups className="h-6 w-6" />,
    permissionName: 'Voir menu comptes agents',
    component: <Comptes />,
    roles: ['ADMIN', 'QUALITY'],
  },
  {
    name: 'gestion_comptes_title',
    layout: '/admin',
    path: 'GestionComptes',
    displayOnSideBar: true,
    icon: <BsPersonFillGear className="h-6 w-6" />,
    permissionName: 'Voir menu gestion des comptes',
    component: <AdminComptes />,
    roles: ['ADMIN'],
  },
  {
    name: 'agent_enterprises_title',
    layout: '/admin',
    path: 'user/enterprises/:id',
    icon: <MdGroups className="h-6 w-6" />,
    displayOnSideBar: false,
    permissionName: 'Entreprises enregistrées par un agent',
    component: <UserEnterprises />,
    roles: ['ADMIN', 'QUALITY'],
  },
  {
    name: 'account_enterprise_title',
    layout: '/admin',
    path: 'account/enterprises',
    icon: <MdAccountTree className="h-6 w-6" />,
    displayOnSideBar: true,
    component: <EnterpriseAcccount />,
    roles: ['ADMIN', 'QUALITY'],
  },
  {
    name: 'detail_account_enterprise_title',
    layout: '/admin',
    path: 'account/enterprises/:id/requests',
    icon: <MdGroups className="h-6 w-6" />,
    displayOnSideBar: false,
    component: <RequestsAccount />,
    roles: ['ADMIN', 'QUALITY'],
  },
  {
    name: 'requests_title',
    layout: '/admin',
    path: 'requests',
    icon: <MdFormatAlignCenter className="h-6 w-6" />,
    displayOnSideBar: true,
    component: <Requests />,
    roles: ['ADMIN', 'QUALITY'],
  },
  {
    name: 'agent_employees_title',
    layout: '/admin',
    path: 'user/enterprises/employes/:userId/:id',
    displayOnSideBar: false,
    icon: <MdGroups className="h-6 w-6" />,
    permissionName: 'Employés enregistrées par un agent',
    component: <UserEmployes />,
    roles: ['ADMIN', 'QUALITY'],
  },
  {
    name: 'roles_permissions_title',
    layout: '/admin',
    path: 'roles',
    displayOnSideBar: true,
    icon: <BsGear className="h-6 w-6" />,
    permissionName: 'Voir menu gestion des roles',
    component: <Roles />,
    roles: ['ADMIN'],
  },
  {
    name: 'notifications_title',
    layout: '/admin',
    path: 'notifications',
    displayOnSideBar: true,
    icon: <BsGear className="h-6 w-6" />,
    permissionName: 'Voir menu notifcations',
    component: <Notifications />,
    roles: ['ADMIN'],
  },
  {
    name: 'Scheduler Notifications',
    layout: '/admin',
    path: 'notification-scheduler',
    displayOnSideBar: true,
    icon: <MdNotificationsActive className="h-6 w-6" />,
    component: <NotificationSchedulerPage />,
    roles: ['ADMIN'],
  },
  {
    name: 'Activité Utilisateurs',
    layout: '/admin',
    path: 'user-activity',
    displayOnSideBar: true,
    icon: <MdReadMore className="h-6 w-6" />,
    // permissionName: 'Voir activité utilisateurs',
    component: <UserActivityPage />,
    roles: ['ADMIN', 'SUPER_ADMIN', 'QUALITY'],
  },
];

export default routes;
